<template>
  <div class="container">
    <h1>
      <b-icon icon="file-earmark-spreadsheet"></b-icon> Warnings

      <div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
<Help id="10" />

</div>
    </h1>
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div class="row">
      <div class="col-md-3 img-responsive">
        <img
          src="../../assets/RegistrationHome.jpg"
          width="350"
          alt="Circle image"
          class="militray-img"
        />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100">Information About Warnings</h1>
            <p>
              These just notify the user about something that may not need immediate action, but could be relevant in the future.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Warnings List</div>
          <div class="panal-body">
            <div
              v-if="message"
              class="alert"
              :class="successful ? 'alert-success' : 'alert-danger'"
            >
              {{ message }}
            </div>
            <div class="table-responsive" v-else>
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Course Name</th>
                    <th scope="col">Course code</th>
                    <th scope="col">Credit Hours</th>
                    <th scope="col">Warning Percentage</th>
                    <!-- <th scope="col">Day and Time</th> -->
                    <!-- <th scope="col">Select</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="courses.length == 0">
                    <td colspan="7">No Data</td>
                  </tr>

                  <tr
                    v-else
                    v-for="item in courses"
                    v-bind:Key="item.StudentID"
                  >
                    <td>{{ item.CourseNameEN }}</td>
                    <td>{{ item.CourseCode }}</td>
                    <td>{{ item.CreditHours }}</td>
                    <td>{{ item.AbcensePercentage }} %</td>
                    <!-- <td>{{ item.SectionsList.map(x=>x.ScheduleLst.map(p=>p.ProfessorLst.map(n=>n.Name))).join(';') }}</td> -->
                    <!-- <td>{{ item.WeekDay  }}  - {{item.StartTime}} - {{item.EndTime}}</td> -->
                   
                    <!-- <td>
                      <b-button
                        variant="success"
                        @click="getQuiz(item)"
                        v-bind:Key="item.CourseNameEN"
                        >Select</b-button
                      >
                      

                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

        
   
   
 
  </div>
</template>
<script>
import studentData from "../../services/student/studentDataServices";
import Help from '../Help.vue';
//import ApplicantService from '../../services/Applicant/Applicant.service';
export default {
  components: { Help },
  name: "Attendance",
  data() {
    return {
      isLoading: true,
      selected: null,
      show: true,
      isHidden: true,
      Grading: [],
      personalData: [],
      message: "",
      courses: "",
      quazs: [],
      CourseNameEN: "",
      currentItem:"",
      info:"",
      checked:false
    };
  },
  // methods:{
  //   getQuiz(item){
      
  //         this.currentItem  = item;
  //         //this.currenUser.StudentID,item.CourseID,item.RoleReviewID  // 25096, 500, 2
  //         studentData.GetStudentActivityGrading(this.currenUser.StudentID,item.CourseID,2).then(
  //            (Response) => {
  //         this.isLoading = false;
  //         this.Grading = Response.data;
  //         // eslint-disable-next-line no-console
  //          console.log(this.Grading);
  //          this.checked =true
  //       },
  //       (error) => {
  //         // eslint-disable-next-line no-console
  //         // console.log(error.response.status);
  //         this.Grading = [];
  //         this.checked =true
  //         this.message =
  //           (error.response &&
  //             error.response.data &&
  //             error.response.data.Message) ||
  //           error.message ||
  //           error.toString();

  //         if (error.response.status == 404) this.message = "";

       
  //       }
      
  //         )
  //   }
  // },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {





    
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.personalData = Response.data.StudentData;
        // eslint-disable-next-line no-console
         console.log(this.personalData);

      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status);

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    ),
      //this.currenUser.StudentID
      // studentData.GetStudentActivityGrading(25096, 366, 3).then(
      //   (Response) => {
      //     this.isLoading = false;
      //     this.Grading = Response.data;
      //     // eslint-disable-next-line no-console
      //     console.log(this.Grading);
      //   },
      //   (error) => {
      //     // eslint-disable-next-line no-console
      //     console.log(error.response.status);

      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // ),
      //this.currenUser.StudentID // 566
      studentData.GetAbsenceWarnings(this.currenUser.StudentID).then(
        (Response) => {
          this.isLoading = false;
          this.courses = Response.data;
          // eslint-disable-next-line no-console
          // console.log(this.Grading);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );

      
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;
 
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}

.profileData, .profileData2 {
    border: 1px dotted #646464;
    padding: 3px 10px;
    font-weight: 700;
    margin: 5px 0px;
}
.profileData {
    color: #285475;
}
.profileData2 {
    color: #ff8600;
}


@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
.model {
  background: rgba(30, 143, 255, 0.13);
  height: 1px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 1s ease 1s, height 1s ease;
  width: 0;
  z-index: 133;
}

.content {
  color: transparent;
  
  font-size: 2em;
  position: absolute;
  top: 50%;
  left:25%;
  transform: translate3d(0, -50%, 0);
  transition: color 0.5s ease;
  width: 50%;
  margin: auto;
}

label {
  color: rgba(30, 143, 255, 0.13);
  cursor: pointer;
  font-family: "Consolas", arial, sans-serif;
  font-size: 2em;
  position: fixed;
  left: 50%;
  top: 50%;
  text-transform: uppercase;
  transform: translate(-50%, -50%);
  transition: color 0.5s ease 0.5s;
}

input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  width: 0;
}
input:focus {
  outline: none;
}

input:checked {
  height: 40px;
  opacity: 1;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 1;
  -webkit-appearance: none;
  width: 40px;
  z-index: 135;
}
input:checked::after, input:checked:before {
  border-top: 1px solid #FFF;
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
  width: 100%;
}
input:checked::after {
  transform: rotate(-45deg);
}

input:checked + label {
  color: #FFF;
  transition: color 0.5s ease;
}

input:checked ~ .model {
  height: 100%;
  width: 100%;
  transition: width 1s ease, height 1s ease 1s;
}
input:checked ~ .model .content {
  color: #FFF;
  transition: color 0.5s ease 0.5s;
}
</style>
